module.exports = __webpack_public_path__ + "media/img/iryo/basic-luggage-15a20fc481f5992f98db26edf6969b54.jpg";